/* eslint-disable no-console, jsx-a11y/anchor-is-valid*/
import React, { useEffect } from 'react';
import { DueDiligence as DueDiligenceType, DueDiligenceChecklist } from 'utils/api/types';
import User from 'auth/User';
import { Tabs } from 'screens/Panel/components';
import Settings from 'screens/Panel/screens/Firm/components/DueDiligence/Settings/Settings';
import Checklist from 'screens/Panel/screens/Firm/components/DueDiligence/Checklist/Checklist';
import { FirmTypes } from 'components/Profile/CmFirmProfile/types';

interface Props {
  firmId: string;
  firmType?: FirmTypes;
  dueDiligence: DueDiligenceType;
  dueDiligenceChecklist: DueDiligenceChecklist;
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
  reloadFirm: () => void;
  user: User;
}

export enum Tab {
  SETTINGS = 'SETTINGS',
  CHECKLIST = 'CHECKLIST',
}

const DueDiligence: React.FC<Props> = ({
  firmId,
  activeTab,
  setActiveTab,
  firmType,
  dueDiligence,
  reloadFirm,
  user,
  dueDiligenceChecklist,
}) => {
  useEffect(() => {
    if (activeTab === Tab.CHECKLIST && firmType !== FirmTypes.DA) {
      setActiveTab(Tab.SETTINGS);
    }
  }, [activeTab, firmType, setActiveTab]);

  

  return (
    <>
      <Tabs.Wrapper style={{ marginBottom: '20px' }}>
        <Tabs.Item>
          <a
            className={activeTab === Tab.SETTINGS ? `active` : ``}
            onClick={() => setActiveTab(Tab.SETTINGS)}>
            Settings
          </a>
        </Tabs.Item>
        {firmType === FirmTypes.DA && (
          <Tabs.Item>
            
            <a
              className={activeTab === Tab.CHECKLIST ? `active` : ``}
              onClick={() => setActiveTab(Tab.CHECKLIST)}>
              Checklist
            </a>
          </Tabs.Item>
        )}
      </Tabs.Wrapper>
      {activeTab === Tab.SETTINGS && (
        <Settings firmId={firmId} firmType={firmType} dueDiligence={dueDiligence} reloadFirm={reloadFirm} user={user} />
      )}
      {activeTab === Tab.CHECKLIST && firmType === FirmTypes.DA && (
        <Checklist firmId={firmId} checklist={dueDiligenceChecklist} reloadFirm={reloadFirm} user={user} />
      )}
    </>
  );
};

export default DueDiligence;
